const content = {
  title: 'Karaa',
  subtitle: 'A technology consulting company',
};

export default content;
